import { render, staticRenderFns } from "./AppointmentInformation.vue?vue&type=template&id=8f6a1d72"
import script from "./AppointmentInformation.vue?vue&type=script&lang=js"
export * from "./AppointmentInformation.vue?vue&type=script&lang=js"
import style0 from "./AppointmentInformation.vue?vue&type=style&index=0&id=8f6a1d72&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports